import React, { FC, ReactNode } from 'react';
import styles from './EmployedsFilterContainer.module.scss';

export interface FilterContainerProps {
  children: ReactNode;
  className?: string;
}

export const EmployedsFilterContainer: FC<FilterContainerProps> = ({
  children,
  className,
}) => {
  return (
    <div className={className ? `${styles.container} ${className}` : styles.container}>
      {children}
    </div>
  );
};
